import React from 'react';
import Modal from '@omilia/modal';

import messages from 'constants/messages';
import WarningModalContent from '../../components/WarningModalContent';

type Props = {
  onSubmit: () => void;
  onCancel: () => void;
};

const ConflictsWarningModal = ({ onSubmit, onCancel }: Props) => (
  <Modal
    open
    glyph="notification-warning"
    hasBackdrop={false}
    title={messages.VERSION_CONTROL.MODAL.GIT_STATUS.ERROR_TITLE_CONFLICTS}
    variant="danger"
  >
    <WarningModalContent
      primaryButton={{
        text: 'Resolve Conflicts',
        onClick: onSubmit,
      }}
      warningText={
        messages.VERSION_CONTROL.MODAL.GIT_STATUS.ERROR_BODY_CONFLICTS
      }
      onCancel={onCancel}
    />
  </Modal>
);

export default ConflictsWarningModal;
